module.exports = __webpack_public_path__ + "web/img/verify3.0a3a7a65.jpg";